module.exports = __webpack_public_path__ + "img/Twitch.c55172a8.svg";